export { default } from './FeaturedProjects';
